import { gameConfigStore } from '@pascal/pascal-core';
import { touchMeGameId } from './gameConstant';

const touchMePigColors = {
  0: 'blue',
  1: 'red',
  2: 'yellow',
};

const catchMePigColors = {
  0: 'red',
  1: 'blue',
  2: 'yellow',
};

const touchMePigIndexes = {
  blue: 0,
  red: 1,
  yellow: 2,
};

const catchMePigIndexes = {
  red: 0,
  blue: 1,
  yellow: 2,
};

export const pigIndexes =
  +gameConfigStore.gameId === touchMeGameId ? touchMePigIndexes : catchMePigIndexes;

export const pigColors =
  +gameConfigStore.gameId === touchMeGameId ? touchMePigColors : catchMePigColors;
